<script>
	import dayjs from 'dayjs';
	import relativeTime from 'dayjs/plugin/relativeTime';
	import { secondsTick } from '@/Stores/Store.js';

	dayjs.extend(relativeTime);

	export let start_time;
	export let negativeAllowed = true;

	$: timeToGo = $secondsTick && formatted();

	/**
	 * convertMsecToHMS via plain Javascript
	 * dayjs has a TZ bug with safari, can't use it
	 */
	function convertMsecToHMS(msec) {
		let timeObject = {};
		timeObject.hh = Math.floor(msec / 1000 / 60 / 60);
		msec -= timeObject.hh * 1000 * 60 * 60;
		timeObject.mm = Math.floor(msec / 1000 / 60);
		msec -= timeObject.mm * 1000 * 60;
		timeObject.ss = Math.floor(msec / 1000);

		return timeObject;
	}

	function formatTimeString(time) {
		if (time.hh >= 1) {
			return time.mm > 0 ? `${time.hh}h ${time.mm}m` : `${time.hh}h`;
		} else {
			return time.mm > 0 ? `${time.mm}m ${time.ss}s` : `${time.ss}s`;
		}
	}

	function formatted() {
		const now = dayjs();
		const startTime = dayjs(start_time);

		if (now.isAfter(startTime)) {
			if (!negativeAllowed) return '0m';

			// anything further back than 12 hours is a mistake
			if (startTime.isBefore(dayjs().subtract(12, 'hour'))) {
				return 'N/A';
			}
			let msec = dayjs(now.valueOf() - startTime.valueOf());
			let time = convertMsecToHMS(msec);

			return '-' + formatTimeString(time);
		} else {
			// anything further out than 1 day, give relative time
			if (startTime.isAfter(dayjs().add(1, 'day'))) {
				return dayjs(start_time).fromNow();
			}

			let msec = dayjs(startTime.valueOf() - now.valueOf());
			let time = convertMsecToHMS(msec);

			return formatTimeString(time);
		}
	}
</script>

<div>{timeToGo}</div>
